export const Checkmark = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M18 6.00012L6 18.0001'
      stroke='#020251'
      stroke-width='3'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M6 6.00012L18 18.0001'
      stroke='#020251'
      stroke-width='3'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
)
